<template>
  <v-card elevation='1'>
    <v-card-text>
      <form @submit.prevent="handleSubmit()">
        <template v-if="!customer">
          <v-row>
            <v-col class="text-center" cols="12" sm="12">
              {{ $t('order.checkin.email_message') }}
            </v-col>
          </v-row>
          <v-row class="d-flex justify-center">
            <v-col cols="12" sm="6">
              <v-text-field
                required
                v-model='email'
                :error-messages='emailErrors'
                prepend-icon="mdi-email-outline"
                @blur="setDirtiness('email')"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col class="text-center">
              <v-btn
                x-large
                color='primary'
                class='mr-2 mb-2'
                type="submit"
                :loading='submitting'
                :disabled="buttonDisabled"
              >
                {{ $t('order.checkin.check_email') }}
              </v-btn>
            </v-col>
          </v-row>
        </template>
      </form>
    </v-card-text>
  </v-card>
</template>

<script>
import { accountDataMixin } from '../../../mixins/account_data_mixin'
import { orderCustomerMixin } from '../../../mixins/order_customer_mixin'
import { validationMixin } from 'vuelidate'
import { required, email } from 'vuelidate/lib/validators'

const FORM_FIELDS = [
  'email'
]

export default {
  mixins: [
    accountDataMixin,
    orderCustomerMixin,
    validationMixin,
  ],
  props: {
    order: {
      type: Object,
      default: () => null,
      required: true
    }
  },
  validations() {
    return {
      email: { required, email }
    }
  },
  methods: {
    handleSubmit() {
      this.submitting = true

      if (!this.$v.$invalid && !this.customer) {
        this.$router.push({
          name: 'CustomerConfirmation',
          params: {
            order: this.order,
            email: this.email
          }
        })
      } else {
        console.log('invalid form!')
      }
    },
    getCurrentValues() {
      const values = {}
      FORM_FIELDS.forEach(field => (values[field] = this[field]))
      return values
    },
    setDirtiness(fieldName) {
      this[fieldName] != this.initialValues[fieldName]
        ? this.$v[fieldName].$touch()
        : this.$v[fieldName].$reset()
    }
  },
  computed: {
    buttonDisabled() {
      return this.$v.$invalid
    }
  },
  created() {
    this.initialValues = this.getCurrentValues()
    this.email = this.customer && this.customer.email
  },
  data() {
    return {
      email: '',
      initialValues: {},
      submitting: false,
      serverSideErrors: {}
    }
  }
}
</script>
